import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createDocumentText } from '../actions/documents'
import { tagFunnel } from '../actions/tagmanager'
import Button from '../components/base/Button'
import { CHECK_MY_PAPER, TEXT_FIELD } from '../util/dataTestIds'

import css from '../util/css'

import styles from './DocumentTextarea.css'

export class DocumentText extends Component {
  constructor(props) {
    super(props)
    this.state = { text: '' }
  }

  handleTextChange(text) {
    this.setState({ text })
  }

  render() {
    return (
      <div className={styles.container}>
        <textarea
          className={css.classNames(styles, 'textarea')}
          onChange={e => this.handleTextChange(e.target.value)}
          rows="15"
          placeholder="Paste your paper here!"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          data-test-id={TEXT_FIELD}
        />
        <Button
          className={css.classNames(styles, 'button')}
          theme={this.props.theme}
          onClick={() => {
            this.props.handleCreateText(this.state.text)
          }}
          disabled={this.state.text.trim().length < 50 || !this.props.initialized}
          fullWidth
          data-id="checkPaperButton"
          data-test-id={CHECK_MY_PAPER}
        >
          Check my paper
        </Button>
      </div>
    )
  }
}

DocumentText.propTypes = {
  handleCreateText: PropTypes.func.isRequired,
  initialized: PropTypes.bool.isRequired,
  theme: PropTypes.string.isRequired,
}

const mapStateToProps = state => ({
  theme: state.theme,
})

const mapDispatchToProps = dispatch => ({
  handleCreateText: text => {
    dispatch(createDocumentText(text))
    dispatch(tagFunnel('upload paper', 'copy and paste'))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(DocumentText)
